import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
//import {ToastComponent} from "../../shared/toast/toast.component";
import * as moment from 'moment';
//import * as _ from 'lodash';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AboutService } from './services/about.service';
import { AuthService } from '../../shared/services/auth.service';
import { TokenStorageService } from '../../shared/services/token-storage.service';
import { User } from '../../models/user.model';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { ChartService } from '../chart/services/chart.service';
import { DashboardData } from 'src/app/models/dashboard.model';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  title = 'about';
  userProfile: User;
  currentSession: string;
  
  constructor(private http: HttpClient,private formBuilder: FormBuilder,
          private modalService: NgbModal, private router: Router,private spinnerService: SpinnerService,
              private aboutService: AboutService,private tokenService: TokenStorageService,
              private authService: AuthService, private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    console.log('--inside  admindash- ngOnInit----');    
    this.saveUserData();
  }

  saveUserData(){
    this.currentSession = this.tokenService.getActiveSession();
    console.log('>>>>>getUserProfile-Admin>>>>>currentSession: ',this.currentSession)
    const userData: User = {
      userName: this.tokenStorageService.getUser(),userRole: this.tokenStorageService.getUserRole(),
      clientName: this.tokenStorageService.getTenantName(), branchCode: this.tokenStorageService.getBranchCode(), ownerName: this.tokenStorageService.getOwnerName()}

    this.aboutService.saveUserData(userData).subscribe({
      next: (response: any) => {
        console.log(">>>saveUserData from service-Admin: "+JSON.stringify(response)); 
        this.userProfile =  response.data;
        //this.router.navigate(['/admin/chart']);
      },
      error: (e) => {
        console.error(e);       
      }
    });
  }
}